import { Pagination, Icon, Button, TextField, Modal, Tooltip, Select, EmptyState, Badge, BlockStack, InlineStack, Text, Card } from '@shopify/polaris';
import React, { useEffect, useRef, useState } from 'react';
import {
    CircleInformationMajor,
    SearchMinor,
} from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import { Table } from 'antd';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png'
import { useDebounce } from '../../useDebounce';
import CancelOrderSkeleton from '../skeleton/CancelOrderSkeleton';
import { getCalculatedAmount } from '../../NewAllSales/Utils/Helper';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}
const gridColumns = [
    {
        title: 'Shopify Order ID',
        dataIndex: 'shopify_order_id',
        width: '150px',
    },
    {
        title: 'Amazon Order ID',
        dataIndex: 'amazon_order_id',
        width: '150px',
    },
    {
        title: 'Reason',
        dataIndex: 'failure_reason',
        width: '200px',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        width: '100px',
    }
];

const shopifyReasons = [
    { label: "Please Select", value: "", disabled: true },
    { label: "Customer", value: "customer" },
    { label: "Inventory", value: "inventory" },
    { label: "Fraud", value: "fraud" },
    { label: "Declined", value: "declined" },
    { label: "Other", value: "other" },
];

const modalGridColumns = [
    {
        title: 'Product Name',
        dataIndex: 'item_name',

    },
    {
        title: 'Inventory',
        dataIndex: 'inventory',

    },
    {
        title: 'Cancelation Reason (Amazon)',
        dataIndex: 'cancellation_reason',
    },
    {
        title: 'Total Item Price',
        dataIndex: 'total_item_price',
    }
];

function CancelledOrders(props: Props) {
    const { t } = useTranslation();

    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [pageCount, setpageCount] = useState<number>(10);
    const [searchValue, setsearchValue] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(false);
    const [gridRows, setgridRows] = useState<any>([]);
    const [modalGridRows, setmodalGridRows] = useState<any>([]);
    const [activateModal, setactivateModal] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>({});
    const [shopifyReason, setShopifyReason] = useState<string>('');
    const [cancelLoader, setCancelLoader] = useState<boolean>(false)
    const [shopifyError, setShopifyError] = useState<boolean>(false);
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);
    const [cancelLoaderGrid, setcancelLoaderGrid] = useState<boolean>(false);
    const [activateConfirmationModal, setactivateConfirmationModal] = useState<boolean>(false);
    const prevInput = useRef('')
    const handlePreviousPagination = () => {
        setActivePage(prev => prev - 1);
    }

    const handleNextPagination = () => {
        setActivePage(prev => prev + 1);
    }

    const getToolTipContent = (data: any, currency: string) => {
        return (
            <BlockStack gap="100">
                <InlineStack gap="400"><Text as='p'>Item Price : </Text><Text as='p'>{currency} {data?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
                <InlineStack gap="400"><Text as='p'>Item Tax : </Text><Text as='p'>{currency} {data?.['tax']?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
                <InlineStack gap="400"><Text as='p'>Item Discount : </Text><Text as='p'>{currency} {data?.['discount']?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
            </BlockStack>
        );
    }

    const getModifiedModalGridRows = (data: any) => {
        let rows: any = [];
        rows = data?.['items']?.map((obj: any, index: number) => {
            let row: any = {
                key: index,
                item_name: obj?.['title'] ?? "",
                inventory: obj?.['qty'] ?? "",
                cancellation_reason: obj?.['marketplace_cancel_reason'] ?? "---",
                total_item_price:
                    <InlineStack gap="500">
                        {getCalculatedAmount({ ...obj })}
                        {/* <Text as='p'>{data?.['marketplace_currency']} {(obj?.['marketplace_price'] * obj?.['qty']) + obj?.['tax']?.['marketplace_price'] ?? 0 - obj?.['discount']?.['marketplace_price'] ?? 0}</Text> */}
                        <Tooltip content={getToolTipContent({ ...obj }, data?.['currency'])}>
                            <div><Icon source={CircleInformationMajor} tone='base' /></div>
                        </Tooltip>
                    </InlineStack>

            }
            return row;
        });
        return rows;
    }

    const handleCancelBtn = async (id: number) => {
        setLoader(true);
        props.di.GET("connector/order/getFailedCancelOrder", {
            "id": id,
        }).then((response: any) => {
            setLoader(false);
            setcancelLoaderGrid(false);
            if (response.success) {
                setModalData({ ...response?.data?.[0] })
                let modalGridRows: any = getModifiedModalGridRows(response?.data?.[0]);
                setmodalGridRows([...modalGridRows]);
                setactivateModal(!activateModal);
            }
            else {
                props.error(t(response.message) ?? t("Oops! Some error occured while getting single order details."))
            }
        })
    }

    const getRows = (data: any) => {
        const rows = data.map((obj: any, index: number) => {
            let row: any = {
                key: obj['user_id'],
                shopify_order_id: obj?.['marketplace_order_id'] ?? obj?.['marketplace_reference_id'],
                amazon_order_id: obj?.['targets']?.[0]?.['order_id'],
                failure_reason: obj?.cancel_failed_reason?.[0] ?? "---",
                action: <Button

                    onClick={() => {
                        handleCancelBtn(obj?._id?.$oid)
                        setcancelLoaderGrid(true);
                    }}
                    loading={cancelLoaderGrid}
                    variant="primary">{t("Cancel Order")}</Button>
            }
            return row;
        })
        return rows;
    }

    const getCancelledOrders = async () => {
        setLoader(true);
        setShowSkeleton(false)
        let obj: any = { activePage: activePage, count: pageCount };
        if (searchValue && searchValue != "") obj['filter[marketplace_reference_id][3]'] = searchValue;
        if (searchValue !== prevInput.current && activePage !== 1) {
            obj.activePage = 1;
            setActivePage(1)
            return;
        }
        let response = await props.di.GET('connector/order/getFailedCancelOrders', obj);
        setLoader(false);
        if (response.success && response?.data?.rows.length > 0) {
            const rows = getRows([...response?.data?.rows]);
            setgridRows([...rows]);
            setTotalPages(Math.ceil(response?.data?.['count'] / pageCount));
            setShowSkeleton(false);
        }
        else {
            setShowSkeleton(true);
            setgridRows([]);
        }
        prevInput.current = searchValue
    }

    const handleCancelOrderModal = () => {
        if (shopifyReason != "") {
            setactivateModal(false);
            setactivateConfirmationModal(true);
        }
        else {
            setShopifyError(true);
            props.error(t("Kindly select shopify reason before proceeding."))
        }
    }

    const handleModalClose = () => {
        setModalData({});
        setmodalGridRows([]);
        setactivateModal(false);
    }

    const debouncedValue = useDebounce(searchValue, 500)
    useEffect(() => {
        getCancelledOrders()
    }, [activePage, debouncedValue]);



    const getModalOrderId = () => {
        let order_id = '';
        modalData?.targets?.map((obj: any) => {
            if (obj?.marketplace == "amazon") {
                order_id = obj?.order_id
            }
        });
        return order_id;
    }

    const handleConfirmationModalClose = () => {
        setactivateConfirmationModal(false);
    }

    const handleConfirmationModal = () => {
        setCancelLoader(true);
        props.di.POST("connector/order/manualCancel", {
            ...modalData, "cancel_reason": shopifyReason
        }).then((response: any) => {
            setCancelLoader(false)
            handleConfirmationModalClose();
            if (response.success) {
                props.success(t(response.message));
                getCancelledOrders();
            }
            else {
                props.error(t(response.message) ?? t("Oops! Some error occured while cancelling order."))
            }
        });
    }

    return (
        <div className='card-box-shadow'>
            <React.Fragment>
                <Modal
                    open={activateConfirmationModal}
                    onClose={() => handleConfirmationModalClose()}
                    title={t(`Failed Canceled Order`)}
                    primaryAction={{
                        content: t('Confirm'),
                        onAction: handleConfirmationModal,
                        loading: cancelLoader
                    }}
                    secondaryActions={[
                        {
                            content: t('No'),
                            onAction: handleConfirmationModalClose,
                            disabled: cancelLoader
                        }
                    ]}
                >
                    <Modal.Section>
                        <Text as='p'>{t("Are you sure you want to cancel this order?")}</Text>
                    </Modal.Section>
                </Modal>
                <Modal
                    open={activateModal}
                    onClose={() => { handleModalClose() }}
                    title={`${t("Failed Canceled Order")}(${getModalOrderId()})`}
                    size="large"
                    primaryAction={{
                        content: ('Confirm'),
                        onAction: handleCancelOrderModal,
                        loading: cancelLoader
                    }}
                    secondaryActions={[
                        {
                            content: t('Cancel'),
                            onAction: handleModalClose,
                        }
                    ]}
                >
                    <Modal.Section>
                        <BlockStack gap="500">
                            <Card padding='0' roundedAbove='sm'>
                                <Table
                                    columns={modalGridColumns}
                                    dataSource={modalGridRows}
                                    scroll={{ x: 800 }}
                                    pagination={false}
                                    loading={loader}
                                    footer={() =>
                                        <InlineStack align='start'>
                                            <div className='Custom-Stack-Item--fill'>
                                                <Text as='p' fontWeight='semibold'>Total Amount</Text>
                                            </div>
                                            <Text as='p'>{modalData?.['marketplace_currency']} {modalData?.['total']?.['marketplace_price']}</Text>
                                        </InlineStack>
                                    }
                                />
                            </Card>
                            <BlockStack gap="200">
                                <InlineStack gap="200">
                                    <Text as='p' fontWeight='semibold'>{t("Canceled Status :")} </Text>
                                    <Badge tone="critical">{modalData?.cancellation_status ?? "---"}</Badge>
                                </InlineStack>
                                <InlineStack gap="200">
                                    <Text as='p' fontWeight='semibold'>Canceled Failed Reason : </Text>
                                    {Array.isArray(modalData?.cancel_failed_reason) ? <Text as='p'>{modalData?.cancel_failed_reason?.[0] ?? "---"}</Text> : <Text as='p'>{modalData?.cancel_failed_reason ?? "---"}</Text>}
                                </InlineStack>
                                <InlineStack gap="200" blockAlign='center'>
                                    <InlineStack gap="100"><Text as='p' tone='critical'>*</Text><Text as='p' fontWeight='semibold'>{t("Shopify Canceled Reason :")}  </Text></InlineStack>
                                    <Select
                                        value={shopifyReason}
                                        onChange={(e) => { setShopifyReason(e); setShopifyError(e == "") }}
                                        label=''
                                        options={shopifyReasons}
                                        error={shopifyError}
                                    />
                                </InlineStack>
                            </BlockStack>
                        </BlockStack>
                    </Modal.Section>
                </Modal>

                <Card roundedAbove='sm'>
                    <BlockStack gap="200">
                        <TextField
                            autoComplete='off'
                            prefix={<div><Icon source={SearchMinor} tone="base" /></div>}
                            label={''}
                            value={searchValue}
                            onChange={(e) => { setsearchValue(e) }}
                            placeholder="Search with Shopify Order Id"
                            clearButton
                            onClearButtonClick={() => setsearchValue('')}
                        />
                        {showSkeleton ? <InlineStack align="center" gap="400">
                            <EmptyState
                                image={NoResultsFound}
                                heading={"No Failed Canceled Orders Found!"}
                            />
                        </InlineStack> : (<>
                            {!loader ? (
                                <Table
                                    columns={gridColumns}
                                    dataSource={gridRows}
                                    scroll={{ x: 850, }}
                                    pagination={false}
                                    loading={loader}
                                    size='middle'
                                />
                            ) : (<CancelOrderSkeleton />)
                            }
                        </>)
                        }
                        {gridRows.length > 0 &&
                            <InlineStack gap="400" align="center">
                                <Pagination
                                    label={`${activePage}/${totalPages}`}
                                    hasPrevious={activePage > 1 && !loader}
                                    onPrevious={() => {
                                        handlePreviousPagination()
                                    }}
                                    hasNext={activePage < totalPages && !loader}
                                    onNext={() => {
                                        handleNextPagination()
                                    }}
                                />
                            </InlineStack>
                        }
                    </BlockStack>
                </Card>
            </React.Fragment>
        </div>
    );
}
export default DI(CancelledOrders);


